<template>
  <div class="uniltwebgl">
    <iframe class="unilt"
            :src=url
            scrolling="no"
            frameborder="0">
    </iframe>
    <div class="back"
         @click="back">
      <van-image width="30"
                 height="30"
                 :src=btnImg />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UniltWebgl',
  data: function () {
    return {
      btnImg: require('@/assets/btn-back.png')
    }
  },
  props: {
    galleryId: {
      type: String,
      default: '5'
    }
  },
  computed: {
    // unilt链接
    url () {
      const url = `http://room.yslt.art/?onSharePage=1&galleryId=${this.galleryId}`
      return url
    }
  },
  methods: {
    // 通知父组件关闭方法
    back () {
      console.log('点击')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
//横屏
@media only screen and (orientation: landscape) {
  .uniltwebgl {
    position: relative;
    // transform: rotate(0deg);
    .unilt {
      // position: absolute;
      width: 100vw;
      height: 100vh;
    }
    .back {
      width: 30px;
      height: 30px;
      position: fixed;
      top: 15px;
      right: 15px;
      z-index: 99999999 !important;
    }
  }
}
//竖屏
@media only screen and (orientation: portrait) {
  .uniltwebgl {
    position: relative;
    transform: rotate(90deg);
    .unilt {
      position: absolute;
      width: 100vh;
      height: 100vw;
    }
    .back {
      width: 30px;
      height: 30px;
      position: fixed;
      top: 15px;
      right: -95vh;
      z-index: 9999999 !important;
    }
  }
}
</style>
